<template>
  <span :title="title">
    <font-awesome-icon :class="className" :icon="icon" />
  </span>
</template>

<script>
export default {
  props: {
    icon: {
      type: [String, Object],
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>